@if (discussions.opened()) {
<aside
  id="discussions-panel"
  data-discussions-panel
  [cdkTrapFocus]="!!(screen.screenSize$ | async)?.isMobile"
  [attr.role]="
    (screen.screenSize$ | async)?.isMobile ? 'dialog' : 'complementary'
  "
  [attr.aria-modal]="(screen.screenSize$ | async)?.isMobile ? 'true' : null"
  class="discussions-panel bg-white dark:bg-black-dark border border-b-0 border-borders-light dark:border-borders-darker shadow-xl"
  [class.discussions-panel-mobile]="(screen.screenSize$ | async)?.isMobile"
  [class.discussions-panel-closing]="discussions.closing()"
  [attr.aria-label]="'DISCUSSIONS.TITLE' | translate"
>
  @if (discussions.restoring()) {
  <app-discussion-panel-header
    [title]="'DISCUSSIONS.LOADING' | translate"
    (back)="discussions.close()"
    (closePanel)="discussions.close()"
  ></app-discussion-panel-header>
  <app-discussion-loading></app-discussion-loading>
  } @else if (discussions.selectedId(); as id) { @for (threadId of [id]; track
  threadId) {
  <app-recommendation-discussion
    #discussion
    class="block h-full min-h-0"
    [threadId]="threadId"
    (reportRequested)="safety.openReport()"
    (blockRequested)="safety.openBlock()"
    (safetyCompleted)="safety.close()"
  ></app-recommendation-discussion>
  <app-discussion-safety-dialog
    #safety
    [modalId]="'discussion-safety-' + id"
    [recipient]="discussion.recipient"
    [pending]="discussion.reporting || discussion.blocking"
    (reportConfirmed)="discussion.report($event)"
    (blockConfirmed)="discussion.setBlocked(true)"
  ></app-discussion-safety-dialog>
  } } @else {
  <app-discussion-panel-header
    [title]="'DISCUSSIONS.TITLE' | translate"
    [scrolled]="scrolled()"
    (back)="discussions.close()"
    (closePanel)="discussions.close()"
  ></app-discussion-panel-header>
  <div class="relative flex flex-1 min-h-0">
    @if (discussions.pendingActivity()) {
    <button
      type="button"
      class="absolute z-10 top-1 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary text-black px-2 py-1 shadow-md"
      (click)="activity()"
    >
      {{ "DISCUSSIONS.ACTIVITY" | translate }} ↑
    </button>
    }
    <div
      #list
      class="flex-1 min-h-0 overflow-y-auto overscroll-contain pb-[var(--sab)]"
      (scroll)="scrollList(list)"
    >
      @for (item of discussions.inbox(); track item._id) {
      <button
        type="button"
        class="flex items-center w-full gap-1.5 p-2 text-left border-b border-borders-light dark:border-borders-darker hover:bg-primary/5 focus-visible:outline-primary"
        (click)="discussions.open(item._id)"
      >
        <span
          class="relative shrink-0 w-[48px] h-[68px] rounded-lg bg-whiteshade dark:bg-blacker"
        >
          @if (item.work.cover) {<img
            class="w-full h-full rounded-lg object-cover"
            [src]="imagesDomain + '/' + item.work.type + item.work.cover"
            alt=""
            loading="lazy"
          />}
          <app-user-avatar
            class="absolute -bottom-[3px] -right-[4px] rounded-full ring-2 ring-white dark:ring-black-dark"
            [name]="friend(item).username"
            [picture]="friend(item).picture"
            [size]="28"
            [online]="discussions.peers.visible(item._id, friend(item)._id)"
          ></app-user-avatar>
        </span>
        <span class="flex-1 min-w-0">
          <span class="flex items-baseline gap-1"
            ><strong class="truncate flex-1">{{
              friend(item).username || ("DISCUSSION.DELETED_USER" | translate)
            }}</strong
            ><time
              class="text-xs whitespace-nowrap text-grey dark:text-lightGrey"
              [class.!text-primary-text]="item.unread"
              [class.dark:!text-primary]="item.unread"
              [class.font-bold]="item.unread"
              [attr.datetime]="item.lastActivityAt"
              >{{ relative(item.lastActivityAt) }}</time
            ></span
          >
          <span class="block truncate text-xs mt-0.5"
            >{{
              (own(item.sender._id)
                ? "DISCUSSIONS.SENT"
                : "DISCUSSIONS.RECEIVED"
              ) | translate
            }}
            ·
            {{
              item.work.title ||
                ("DISCUSSION.HISTORICAL_TITLE_MISSING" | translate)
            }}</span
          >
          <span
            class="block truncate text-sm mt-0.5 text-grey dark:text-lightGrey"
            [class.font-bold]="item.unread"
          >
            @if (own(item.lastMessage?.authorId || item.sender._id)) {
            {{ "DISCUSSIONS.YOU" | translate }} }
            <app-discussion-preview
              [entry]="item.lastMessage"
              [fallback]="item.comment"
              [originModeratedAt]="item.commentModeratedAt"
              spoilerLabel="DISCUSSIONS.SPOILER_PREVIEW"
            ></app-discussion-preview>
          </span>
        </span>
        @if (item.unread) {<span
          class="w-[7px] h-[7px] shrink-0 rounded-full bg-primary"
          [attr.aria-label]="'DISCUSSION.NEW' | translate"
        ></span
        >}
      </button>
      } @if (discussions.inboxLoading()) {
      <app-discussion-loading
        [class.sr-only]="discussions.inbox().length > 0"
      ></app-discussion-loading>
      } @else if (discussions.inboxError()) {
      <p class="p-3 text-center" role="alert">
        {{ "DISCUSSION.LOAD_ERROR" | translate }}
        <button
          type="button"
          class="underline"
          (click)="discussions.refreshInbox()"
        >
          {{ "DISCUSSION.RETRY" | translate }}
        </button>
      </p>
      } @else if (!discussions.inbox().length) {
      <p class="p-3 text-center text-grey dark:text-lightGrey">
        {{ "DISCUSSIONS.EMPTY" | translate }}
      </p>
      }
    </div>
  </div>
  }
</aside>
}
